/**
 * Our Corporate Clients Dataset
 * Sourced directly from toprollingshutters.in/our-clients/ (114 authentic logos)
 * plus major enterprise installations across Hyderabad & Telangana.
 */

export const CLIENT_SECTORS = [
  'All Clients',
  'Retail & Showrooms',
  'Warehouses & Logistics',
  'Industrial & Manufacturing',
  'Commercial Offices',
  'Healthcare & Hospitality',
  'Automotive & Workshops'
];

export const CLIENTS_DATA = [
  {
    "id": "ent-1",
    "name": "Apollo Hospitals Group",
    "sector": "Healthcare & Hospitality",
    "locality": "Jubilee Hills & Secunderabad",
    "shutterType": "Fire-Rated Safety & Emergency Rapid Doors",
    "logo": "assets/images/clients/01.jpg",
    "featured": true
  },
  {
    "id": "ent-2",
    "name": "L&T Metro Rail Hyderabad",
    "sector": "Automotive & Workshops",
    "locality": "Ameerpet & Miyapur Concourse",
    "shutterType": "Heavy-Duty Motorized Security Grilles",
    "logo": "assets/images/clients/02.jpg",
    "featured": true
  },
  {
    "id": "ent-3",
    "name": "Amazon Fulfillment Logistics",
    "sector": "Warehouses & Logistics",
    "locality": "Shamshabad Air Cargo Corridor",
    "shutterType": "High-Speed Rapid Roll-Up Industrial Doors",
    "logo": "assets/images/clients/03.jpg",
    "featured": true
  },
  {
    "id": "ent-4",
    "name": "DMart Hypermarket Stores",
    "sector": "Retail & Showrooms",
    "locality": "Kukatpally & LB Nagar Hubs",
    "shutterType": "Perforated Commercial Steel Rolling Shutters",
    "logo": "assets/images/clients/04.jpg",
    "featured": true
  },
  {
    "id": "ent-5",
    "name": "BigBasket Regional Distribution",
    "sector": "Warehouses & Logistics",
    "locality": "Medchal & Kompally Logistics Park",
    "shutterType": "Insulated Cold-Chain Rolling Shutters",
    "logo": "assets/images/clients/05.jpg",
    "featured": true
  },
  {
    "id": "ent-6",
    "name": "Reliance Retail & Smart Bazaar",
    "sector": "Retail & Showrooms",
    "locality": "Gachibowli & Kondapur Outlets",
    "shutterType": "Motorized Aluminium Storefront Shutters",
    "logo": "assets/images/clients/06.jpg",
    "featured": true
  },
  {
    "id": "ent-7",
    "name": "Decathlon Sports Flagship",
    "sector": "Retail & Showrooms",
    "locality": "Shamshabad & Uppal Stores",
    "shutterType": "Wide-Span Motorized High-Lift Shutters",
    "logo": "assets/images/clients/07.jpg",
    "featured": true
  },
  {
    "id": "ent-8",
    "name": "Dr. Reddy's Laboratories",
    "sector": "Industrial & Manufacturing",
    "locality": "Bollaram & Bachupally Plants",
    "shutterType": "Dust-Proof Cleanroom Rapid Roll-Up Doors",
    "logo": "assets/images/clients/08.jpg",
    "featured": true
  },
  {
    "id": "ent-9",
    "name": "Tata BlueScope Steel Logistics",
    "sector": "Industrial & Manufacturing",
    "locality": "Cherlapally Industrial Estate",
    "shutterType": "Heavy Industrial Gearbox Rolling Doors",
    "logo": "assets/images/clients/09.jpg",
    "featured": true
  },
  {
    "id": "ent-10",
    "name": "Ramoji Film City Studios",
    "sector": "Commercial Offices",
    "locality": "Hayathnagar Complex",
    "shutterType": "Custom Acoustic & Large-Span Studio Shutters",
    "logo": "assets/images/clients/10.jpg",
    "featured": true
  },
  {
    "id": "ent-11",
    "name": "GMR Air Cargo Terminal",
    "sector": "Warehouses & Logistics",
    "locality": "RGIA Cargo Village, Shamshabad",
    "shutterType": "Anti-Drop Safety Motorized Cargo Shutters",
    "logo": "assets/images/clients/100.jpg",
    "featured": true
  },
  {
    "id": "ent-12",
    "name": "MedPlus Healthcare Hubs",
    "sector": "Retail & Showrooms",
    "locality": "50+ Branches Across Hyderabad",
    "shutterType": "Perforated Commercial Security Shutters",
    "logo": "assets/images/clients/101.jpg",
    "featured": true
  },
  {
    "id": "ent-13",
    "name": "Asian Paints Distribution Hub",
    "sector": "Industrial & Manufacturing",
    "locality": "Jeedimetla Phase-1",
    "shutterType": "Flameproof Motorized Heavy Drum Shutters",
    "logo": "assets/images/clients/102.jpg",
    "featured": true
  },
  {
    "id": "ent-14",
    "name": "Schneider Electric Smart Plant",
    "sector": "Industrial & Manufacturing",
    "locality": "Gachibowli Tech Zone",
    "shutterType": "Sensor-Integrated High-Speed Clean Doors",
    "logo": "assets/images/clients/103.jpg",
    "featured": true
  },
  {
    "id": "ent-15",
    "name": "Swiggy Instamart Fulfillment Hubs",
    "sector": "Warehouses & Logistics",
    "locality": "Cyberabad Urban Pods",
    "shutterType": "Automated High-Frequency Access Shutters",
    "logo": "assets/images/clients/104.jpg",
    "featured": true
  },
  {
    "id": "c-1",
    "name": "Corporate Client Partner #01",
    "sector": "Retail & Showrooms",
    "locality": "Kukatpally, Hyderabad",
    "shutterType": "Heavy Duty Motorized Rolling Shutter",
    "logo": "assets/images/clients/01.jpg",
    "featured": true
  },
  {
    "id": "c-2",
    "name": "Corporate Client Partner #02",
    "sector": "Warehouses & Logistics",
    "locality": "Madhapur, Hyderabad",
    "shutterType": "Perforated See-Through Security Shutter",
    "logo": "assets/images/clients/02.jpg",
    "featured": true
  },
  {
    "id": "c-3",
    "name": "Corporate Client Partner #03",
    "sector": "Industrial & Manufacturing",
    "locality": "Gachibowli, Hyderabad",
    "shutterType": "Galvanized Steel Industrial Shutter",
    "logo": "assets/images/clients/03.jpg",
    "featured": true
  },
  {
    "id": "c-4",
    "name": "Corporate Client Partner #04",
    "sector": "Commercial Offices",
    "locality": "Balanagar Industrial Area",
    "shutterType": "Transparent Polycarbonate Display Shutter",
    "logo": "assets/images/clients/04.jpg",
    "featured": true
  },
  {
    "id": "c-5",
    "name": "Corporate Client Partner #05",
    "sector": "Healthcare & Hospitality",
    "locality": "Jeedimetla Industrial Estate",
    "shutterType": "High-Speed Rapid Roll-Up Door",
    "logo": "assets/images/clients/05.jpg",
    "featured": true
  },
  {
    "id": "c-6",
    "name": "Corporate Client Partner #06",
    "sector": "Automotive & Workshops",
    "locality": "Cherlapally Industrial Belt",
    "shutterType": "Fire-Rated 4-Hour Steel Shutter",
    "logo": "assets/images/clients/06.jpg",
    "featured": true
  },
  {
    "id": "c-7",
    "name": "Corporate Client Partner #07",
    "sector": "Retail & Showrooms",
    "locality": "Secunderabad Commercial Zone",
    "shutterType": "Automatic Remote-Controlled Shutter",
    "logo": "assets/images/clients/07.jpg",
    "featured": true
  },
  {
    "id": "c-8",
    "name": "Corporate Client Partner #08",
    "sector": "Warehouses & Logistics",
    "locality": "Ameerpet, Hyderabad",
    "shutterType": "Architectural Aluminium Rolling Shutter",
    "logo": "assets/images/clients/08.jpg",
    "featured": true
  },
  {
    "id": "c-9",
    "name": "Corporate Client Partner #09",
    "sector": "Industrial & Manufacturing",
    "locality": "LB Nagar Corridor",
    "shutterType": "Heavy Duty Motorized Rolling Shutter",
    "logo": "assets/images/clients/09.jpg",
    "featured": true
  },
  {
    "id": "c-10",
    "name": "Corporate Client Partner #10",
    "sector": "Commercial Offices",
    "locality": "Kondapur, Hyderabad",
    "shutterType": "Perforated See-Through Security Shutter",
    "logo": "assets/images/clients/10.jpg",
    "featured": true
  },
  {
    "id": "c-11",
    "name": "Corporate Client Partner #100",
    "sector": "Healthcare & Hospitality",
    "locality": "Sanathnagar Industrial Area",
    "shutterType": "Galvanized Steel Industrial Shutter",
    "logo": "assets/images/clients/100.jpg",
    "featured": true
  },
  {
    "id": "c-12",
    "name": "Corporate Client Partner #101",
    "sector": "Automotive & Workshops",
    "locality": "Nacharam Industrial Area",
    "shutterType": "Transparent Polycarbonate Display Shutter",
    "logo": "assets/images/clients/101.jpg",
    "featured": true
  },
  {
    "id": "c-13",
    "name": "Corporate Client Partner #102",
    "sector": "Retail & Showrooms",
    "locality": "Shamshabad Logistics Hub",
    "shutterType": "High-Speed Rapid Roll-Up Door",
    "logo": "assets/images/clients/102.jpg",
    "featured": true
  },
  {
    "id": "c-14",
    "name": "Corporate Client Partner #103",
    "sector": "Warehouses & Logistics",
    "locality": "Miyapur, Hyderabad",
    "shutterType": "Fire-Rated 4-Hour Steel Shutter",
    "logo": "assets/images/clients/103.jpg",
    "featured": true
  },
  {
    "id": "c-15",
    "name": "Corporate Client Partner #104",
    "sector": "Industrial & Manufacturing",
    "locality": "Banjara Hills, Hyderabad",
    "shutterType": "Automatic Remote-Controlled Shutter",
    "logo": "assets/images/clients/104.jpg",
    "featured": true
  },
  {
    "id": "c-16",
    "name": "Corporate Client Partner #105",
    "sector": "Commercial Offices",
    "locality": "Jubilee Hills, Hyderabad",
    "shutterType": "Architectural Aluminium Rolling Shutter",
    "logo": "assets/images/clients/105.jpg",
    "featured": true
  },
  {
    "id": "c-17",
    "name": "Corporate Client Partner #106",
    "sector": "Healthcare & Hospitality",
    "locality": "Begumpet Commercial Hub",
    "shutterType": "Heavy Duty Motorized Rolling Shutter",
    "logo": "assets/images/clients/106.jpg",
    "featured": true
  },
  {
    "id": "c-18",
    "name": "Corporate Client Partner #107",
    "sector": "Automotive & Workshops",
    "locality": "Uppal Industrial Area",
    "shutterType": "Perforated See-Through Security Shutter",
    "logo": "assets/images/clients/107.jpg",
    "featured": true
  },
  {
    "id": "c-19",
    "name": "Corporate Client Partner #108",
    "sector": "Retail & Showrooms",
    "locality": "Kukatpally, Hyderabad",
    "shutterType": "Galvanized Steel Industrial Shutter",
    "logo": "assets/images/clients/108.jpg",
    "featured": false
  },
  {
    "id": "c-20",
    "name": "Corporate Client Partner #109",
    "sector": "Warehouses & Logistics",
    "locality": "Madhapur, Hyderabad",
    "shutterType": "Transparent Polycarbonate Display Shutter",
    "logo": "assets/images/clients/109.jpg",
    "featured": false
  },
  {
    "id": "c-21",
    "name": "Corporate Client Partner #11",
    "sector": "Industrial & Manufacturing",
    "locality": "Gachibowli, Hyderabad",
    "shutterType": "High-Speed Rapid Roll-Up Door",
    "logo": "assets/images/clients/11.jpg",
    "featured": false
  },
  {
    "id": "c-22",
    "name": "Corporate Client Partner #110",
    "sector": "Commercial Offices",
    "locality": "Balanagar Industrial Area",
    "shutterType": "Fire-Rated 4-Hour Steel Shutter",
    "logo": "assets/images/clients/110.jpg",
    "featured": false
  },
  {
    "id": "c-23",
    "name": "Corporate Client Partner #111",
    "sector": "Healthcare & Hospitality",
    "locality": "Jeedimetla Industrial Estate",
    "shutterType": "Automatic Remote-Controlled Shutter",
    "logo": "assets/images/clients/111.jpg",
    "featured": false
  },
  {
    "id": "c-24",
    "name": "Corporate Client Partner #112",
    "sector": "Automotive & Workshops",
    "locality": "Cherlapally Industrial Belt",
    "shutterType": "Architectural Aluminium Rolling Shutter",
    "logo": "assets/images/clients/112.jpg",
    "featured": false
  },
  {
    "id": "c-25",
    "name": "Corporate Client Partner #113",
    "sector": "Retail & Showrooms",
    "locality": "Secunderabad Commercial Zone",
    "shutterType": "Heavy Duty Motorized Rolling Shutter",
    "logo": "assets/images/clients/113.jpg",
    "featured": false
  },
  {
    "id": "c-26",
    "name": "Corporate Client Partner #114",
    "sector": "Warehouses & Logistics",
    "locality": "Ameerpet, Hyderabad",
    "shutterType": "Perforated See-Through Security Shutter",
    "logo": "assets/images/clients/114.jpg",
    "featured": false
  },
  {
    "id": "c-27",
    "name": "Corporate Client Partner #115",
    "sector": "Industrial & Manufacturing",
    "locality": "LB Nagar Corridor",
    "shutterType": "Galvanized Steel Industrial Shutter",
    "logo": "assets/images/clients/115.jpg",
    "featured": false
  },
  {
    "id": "c-28",
    "name": "Corporate Client Partner #116",
    "sector": "Commercial Offices",
    "locality": "Kondapur, Hyderabad",
    "shutterType": "Transparent Polycarbonate Display Shutter",
    "logo": "assets/images/clients/116.jpg",
    "featured": false
  },
  {
    "id": "c-29",
    "name": "Corporate Client Partner #117",
    "sector": "Healthcare & Hospitality",
    "locality": "Sanathnagar Industrial Area",
    "shutterType": "High-Speed Rapid Roll-Up Door",
    "logo": "assets/images/clients/117.jpg",
    "featured": false
  },
  {
    "id": "c-30",
    "name": "Corporate Client Partner #118",
    "sector": "Automotive & Workshops",
    "locality": "Nacharam Industrial Area",
    "shutterType": "Fire-Rated 4-Hour Steel Shutter",
    "logo": "assets/images/clients/118.jpg",
    "featured": false
  },
  {
    "id": "c-31",
    "name": "Corporate Client Partner #119",
    "sector": "Retail & Showrooms",
    "locality": "Shamshabad Logistics Hub",
    "shutterType": "Automatic Remote-Controlled Shutter",
    "logo": "assets/images/clients/119.jpg",
    "featured": false
  },
  {
    "id": "c-32",
    "name": "Corporate Client Partner #12",
    "sector": "Warehouses & Logistics",
    "locality": "Miyapur, Hyderabad",
    "shutterType": "Architectural Aluminium Rolling Shutter",
    "logo": "assets/images/clients/12.jpg",
    "featured": false
  },
  {
    "id": "c-33",
    "name": "Corporate Client Partner #120",
    "sector": "Industrial & Manufacturing",
    "locality": "Banjara Hills, Hyderabad",
    "shutterType": "Heavy Duty Motorized Rolling Shutter",
    "logo": "assets/images/clients/120.jpg",
    "featured": false
  },
  {
    "id": "c-34",
    "name": "Corporate Client Partner #121",
    "sector": "Commercial Offices",
    "locality": "Jubilee Hills, Hyderabad",
    "shutterType": "Perforated See-Through Security Shutter",
    "logo": "assets/images/clients/121.jpg",
    "featured": false
  },
  {
    "id": "c-35",
    "name": "Corporate Client Partner #122",
    "sector": "Healthcare & Hospitality",
    "locality": "Begumpet Commercial Hub",
    "shutterType": "Galvanized Steel Industrial Shutter",
    "logo": "assets/images/clients/122.jpg",
    "featured": false
  },
  {
    "id": "c-36",
    "name": "Corporate Client Partner #123",
    "sector": "Automotive & Workshops",
    "locality": "Uppal Industrial Area",
    "shutterType": "Transparent Polycarbonate Display Shutter",
    "logo": "assets/images/clients/123.jpg",
    "featured": false
  },
  {
    "id": "c-37",
    "name": "Corporate Client Partner #13",
    "sector": "Retail & Showrooms",
    "locality": "Kukatpally, Hyderabad",
    "shutterType": "High-Speed Rapid Roll-Up Door",
    "logo": "assets/images/clients/13.jpg",
    "featured": false
  },
  {
    "id": "c-38",
    "name": "Corporate Client Partner #14",
    "sector": "Warehouses & Logistics",
    "locality": "Madhapur, Hyderabad",
    "shutterType": "Fire-Rated 4-Hour Steel Shutter",
    "logo": "assets/images/clients/14.jpg",
    "featured": false
  },
  {
    "id": "c-39",
    "name": "Corporate Client Partner #15",
    "sector": "Industrial & Manufacturing",
    "locality": "Gachibowli, Hyderabad",
    "shutterType": "Automatic Remote-Controlled Shutter",
    "logo": "assets/images/clients/15.jpg",
    "featured": false
  },
  {
    "id": "c-40",
    "name": "Corporate Client Partner #16",
    "sector": "Commercial Offices",
    "locality": "Balanagar Industrial Area",
    "shutterType": "Architectural Aluminium Rolling Shutter",
    "logo": "assets/images/clients/16.jpg",
    "featured": false
  },
  {
    "id": "c-41",
    "name": "Corporate Client Partner #17",
    "sector": "Healthcare & Hospitality",
    "locality": "Jeedimetla Industrial Estate",
    "shutterType": "Heavy Duty Motorized Rolling Shutter",
    "logo": "assets/images/clients/17.jpg",
    "featured": false
  },
  {
    "id": "c-42",
    "name": "Corporate Client Partner #18",
    "sector": "Automotive & Workshops",
    "locality": "Cherlapally Industrial Belt",
    "shutterType": "Perforated See-Through Security Shutter",
    "logo": "assets/images/clients/18.jpg",
    "featured": false
  },
  {
    "id": "c-43",
    "name": "Corporate Client Partner #19",
    "sector": "Retail & Showrooms",
    "locality": "Secunderabad Commercial Zone",
    "shutterType": "Galvanized Steel Industrial Shutter",
    "logo": "assets/images/clients/19.jpg",
    "featured": false
  },
  {
    "id": "c-44",
    "name": "Corporate Client Partner #20",
    "sector": "Warehouses & Logistics",
    "locality": "Ameerpet, Hyderabad",
    "shutterType": "Transparent Polycarbonate Display Shutter",
    "logo": "assets/images/clients/20.jpg",
    "featured": false
  },
  {
    "id": "c-45",
    "name": "Corporate Client Partner #21",
    "sector": "Industrial & Manufacturing",
    "locality": "LB Nagar Corridor",
    "shutterType": "High-Speed Rapid Roll-Up Door",
    "logo": "assets/images/clients/21.jpg",
    "featured": false
  },
  {
    "id": "c-46",
    "name": "Corporate Client Partner #22",
    "sector": "Commercial Offices",
    "locality": "Kondapur, Hyderabad",
    "shutterType": "Fire-Rated 4-Hour Steel Shutter",
    "logo": "assets/images/clients/22.jpg",
    "featured": false
  },
  {
    "id": "c-47",
    "name": "Corporate Client Partner #23",
    "sector": "Healthcare & Hospitality",
    "locality": "Sanathnagar Industrial Area",
    "shutterType": "Automatic Remote-Controlled Shutter",
    "logo": "assets/images/clients/23.jpg",
    "featured": false
  },
  {
    "id": "c-48",
    "name": "Corporate Client Partner #24",
    "sector": "Automotive & Workshops",
    "locality": "Nacharam Industrial Area",
    "shutterType": "Architectural Aluminium Rolling Shutter",
    "logo": "assets/images/clients/24.jpg",
    "featured": false
  },
  {
    "id": "c-49",
    "name": "Corporate Client Partner #25",
    "sector": "Retail & Showrooms",
    "locality": "Shamshabad Logistics Hub",
    "shutterType": "Heavy Duty Motorized Rolling Shutter",
    "logo": "assets/images/clients/25.jpg",
    "featured": false
  },
  {
    "id": "c-50",
    "name": "Corporate Client Partner #26",
    "sector": "Warehouses & Logistics",
    "locality": "Miyapur, Hyderabad",
    "shutterType": "Perforated See-Through Security Shutter",
    "logo": "assets/images/clients/26.jpg",
    "featured": false
  },
  {
    "id": "c-51",
    "name": "Corporate Client Partner #27",
    "sector": "Industrial & Manufacturing",
    "locality": "Banjara Hills, Hyderabad",
    "shutterType": "Galvanized Steel Industrial Shutter",
    "logo": "assets/images/clients/27.jpg",
    "featured": false
  },
  {
    "id": "c-52",
    "name": "Corporate Client Partner #28",
    "sector": "Commercial Offices",
    "locality": "Jubilee Hills, Hyderabad",
    "shutterType": "Transparent Polycarbonate Display Shutter",
    "logo": "assets/images/clients/28.jpg",
    "featured": false
  },
  {
    "id": "c-53",
    "name": "Corporate Client Partner #29",
    "sector": "Healthcare & Hospitality",
    "locality": "Begumpet Commercial Hub",
    "shutterType": "High-Speed Rapid Roll-Up Door",
    "logo": "assets/images/clients/29.jpg",
    "featured": false
  },
  {
    "id": "c-54",
    "name": "Corporate Client Partner #30",
    "sector": "Automotive & Workshops",
    "locality": "Uppal Industrial Area",
    "shutterType": "Fire-Rated 4-Hour Steel Shutter",
    "logo": "assets/images/clients/30.jpg",
    "featured": false
  },
  {
    "id": "c-55",
    "name": "Corporate Client Partner #31",
    "sector": "Retail & Showrooms",
    "locality": "Kukatpally, Hyderabad",
    "shutterType": "Automatic Remote-Controlled Shutter",
    "logo": "assets/images/clients/31.jpg",
    "featured": false
  },
  {
    "id": "c-56",
    "name": "Corporate Client Partner #32",
    "sector": "Warehouses & Logistics",
    "locality": "Madhapur, Hyderabad",
    "shutterType": "Architectural Aluminium Rolling Shutter",
    "logo": "assets/images/clients/32.jpg",
    "featured": false
  },
  {
    "id": "c-57",
    "name": "Corporate Client Partner #33",
    "sector": "Industrial & Manufacturing",
    "locality": "Gachibowli, Hyderabad",
    "shutterType": "Heavy Duty Motorized Rolling Shutter",
    "logo": "assets/images/clients/33.jpg",
    "featured": false
  },
  {
    "id": "c-58",
    "name": "Corporate Client Partner #34",
    "sector": "Commercial Offices",
    "locality": "Balanagar Industrial Area",
    "shutterType": "Perforated See-Through Security Shutter",
    "logo": "assets/images/clients/34.jpg",
    "featured": false
  },
  {
    "id": "c-59",
    "name": "Corporate Client Partner #35",
    "sector": "Healthcare & Hospitality",
    "locality": "Jeedimetla Industrial Estate",
    "shutterType": "Galvanized Steel Industrial Shutter",
    "logo": "assets/images/clients/35.jpg",
    "featured": false
  },
  {
    "id": "c-60",
    "name": "Corporate Client Partner #36",
    "sector": "Automotive & Workshops",
    "locality": "Cherlapally Industrial Belt",
    "shutterType": "Transparent Polycarbonate Display Shutter",
    "logo": "assets/images/clients/36.jpg",
    "featured": false
  },
  {
    "id": "c-61",
    "name": "Corporate Client Partner #37",
    "sector": "Retail & Showrooms",
    "locality": "Secunderabad Commercial Zone",
    "shutterType": "High-Speed Rapid Roll-Up Door",
    "logo": "assets/images/clients/37.jpg",
    "featured": false
  },
  {
    "id": "c-62",
    "name": "Corporate Client Partner #38",
    "sector": "Warehouses & Logistics",
    "locality": "Ameerpet, Hyderabad",
    "shutterType": "Fire-Rated 4-Hour Steel Shutter",
    "logo": "assets/images/clients/38.jpg",
    "featured": false
  },
  {
    "id": "c-63",
    "name": "Corporate Client Partner #39",
    "sector": "Industrial & Manufacturing",
    "locality": "LB Nagar Corridor",
    "shutterType": "Automatic Remote-Controlled Shutter",
    "logo": "assets/images/clients/39.jpg",
    "featured": false
  },
  {
    "id": "c-64",
    "name": "Corporate Client Partner #40",
    "sector": "Commercial Offices",
    "locality": "Kondapur, Hyderabad",
    "shutterType": "Architectural Aluminium Rolling Shutter",
    "logo": "assets/images/clients/40.jpg",
    "featured": false
  },
  {
    "id": "c-65",
    "name": "Corporate Client Partner #41",
    "sector": "Healthcare & Hospitality",
    "locality": "Sanathnagar Industrial Area",
    "shutterType": "Heavy Duty Motorized Rolling Shutter",
    "logo": "assets/images/clients/41.jpg",
    "featured": false
  },
  {
    "id": "c-66",
    "name": "Corporate Client Partner #42",
    "sector": "Automotive & Workshops",
    "locality": "Nacharam Industrial Area",
    "shutterType": "Perforated See-Through Security Shutter",
    "logo": "assets/images/clients/42.jpg",
    "featured": false
  },
  {
    "id": "c-67",
    "name": "Corporate Client Partner #43",
    "sector": "Retail & Showrooms",
    "locality": "Shamshabad Logistics Hub",
    "shutterType": "Galvanized Steel Industrial Shutter",
    "logo": "assets/images/clients/43.jpg",
    "featured": false
  },
  {
    "id": "c-68",
    "name": "Corporate Client Partner #46",
    "sector": "Warehouses & Logistics",
    "locality": "Miyapur, Hyderabad",
    "shutterType": "Transparent Polycarbonate Display Shutter",
    "logo": "assets/images/clients/46.jpg",
    "featured": false
  },
  {
    "id": "c-69",
    "name": "Corporate Client Partner #47",
    "sector": "Industrial & Manufacturing",
    "locality": "Banjara Hills, Hyderabad",
    "shutterType": "High-Speed Rapid Roll-Up Door",
    "logo": "assets/images/clients/47.jpg",
    "featured": false
  },
  {
    "id": "c-70",
    "name": "Corporate Client Partner #48",
    "sector": "Commercial Offices",
    "locality": "Jubilee Hills, Hyderabad",
    "shutterType": "Fire-Rated 4-Hour Steel Shutter",
    "logo": "assets/images/clients/48.jpg",
    "featured": false
  },
  {
    "id": "c-71",
    "name": "Corporate Client Partner #49",
    "sector": "Healthcare & Hospitality",
    "locality": "Begumpet Commercial Hub",
    "shutterType": "Automatic Remote-Controlled Shutter",
    "logo": "assets/images/clients/49.jpg",
    "featured": false
  },
  {
    "id": "c-72",
    "name": "Corporate Client Partner #51",
    "sector": "Automotive & Workshops",
    "locality": "Uppal Industrial Area",
    "shutterType": "Architectural Aluminium Rolling Shutter",
    "logo": "assets/images/clients/51.jpg",
    "featured": false
  },
  {
    "id": "c-73",
    "name": "Corporate Client Partner #52",
    "sector": "Retail & Showrooms",
    "locality": "Kukatpally, Hyderabad",
    "shutterType": "Heavy Duty Motorized Rolling Shutter",
    "logo": "assets/images/clients/52.jpg",
    "featured": false
  },
  {
    "id": "c-74",
    "name": "Corporate Client Partner #54",
    "sector": "Warehouses & Logistics",
    "locality": "Madhapur, Hyderabad",
    "shutterType": "Perforated See-Through Security Shutter",
    "logo": "assets/images/clients/54.jpg",
    "featured": false
  },
  {
    "id": "c-75",
    "name": "Corporate Client Partner #55",
    "sector": "Industrial & Manufacturing",
    "locality": "Gachibowli, Hyderabad",
    "shutterType": "Galvanized Steel Industrial Shutter",
    "logo": "assets/images/clients/55.jpg",
    "featured": false
  },
  {
    "id": "c-76",
    "name": "Corporate Client Partner #56",
    "sector": "Commercial Offices",
    "locality": "Balanagar Industrial Area",
    "shutterType": "Transparent Polycarbonate Display Shutter",
    "logo": "assets/images/clients/56.jpg",
    "featured": false
  },
  {
    "id": "c-77",
    "name": "Corporate Client Partner #58",
    "sector": "Healthcare & Hospitality",
    "locality": "Jeedimetla Industrial Estate",
    "shutterType": "High-Speed Rapid Roll-Up Door",
    "logo": "assets/images/clients/58.jpg",
    "featured": false
  },
  {
    "id": "c-78",
    "name": "Corporate Client Partner #59",
    "sector": "Automotive & Workshops",
    "locality": "Cherlapally Industrial Belt",
    "shutterType": "Fire-Rated 4-Hour Steel Shutter",
    "logo": "assets/images/clients/59.jpg",
    "featured": false
  },
  {
    "id": "c-79",
    "name": "Corporate Client Partner #60",
    "sector": "Retail & Showrooms",
    "locality": "Secunderabad Commercial Zone",
    "shutterType": "Automatic Remote-Controlled Shutter",
    "logo": "assets/images/clients/60.jpg",
    "featured": false
  },
  {
    "id": "c-80",
    "name": "Corporate Client Partner #61",
    "sector": "Warehouses & Logistics",
    "locality": "Ameerpet, Hyderabad",
    "shutterType": "Architectural Aluminium Rolling Shutter",
    "logo": "assets/images/clients/61.jpg",
    "featured": false
  },
  {
    "id": "c-81",
    "name": "Corporate Client Partner #62",
    "sector": "Industrial & Manufacturing",
    "locality": "LB Nagar Corridor",
    "shutterType": "Heavy Duty Motorized Rolling Shutter",
    "logo": "assets/images/clients/62.jpg",
    "featured": false
  },
  {
    "id": "c-82",
    "name": "Corporate Client Partner #63",
    "sector": "Commercial Offices",
    "locality": "Kondapur, Hyderabad",
    "shutterType": "Perforated See-Through Security Shutter",
    "logo": "assets/images/clients/63.jpg",
    "featured": false
  },
  {
    "id": "c-83",
    "name": "Corporate Client Partner #64",
    "sector": "Healthcare & Hospitality",
    "locality": "Sanathnagar Industrial Area",
    "shutterType": "Galvanized Steel Industrial Shutter",
    "logo": "assets/images/clients/64.jpg",
    "featured": false
  },
  {
    "id": "c-84",
    "name": "Corporate Client Partner #67",
    "sector": "Automotive & Workshops",
    "locality": "Nacharam Industrial Area",
    "shutterType": "Transparent Polycarbonate Display Shutter",
    "logo": "assets/images/clients/67.jpg",
    "featured": false
  },
  {
    "id": "c-85",
    "name": "Corporate Client Partner #68",
    "sector": "Retail & Showrooms",
    "locality": "Shamshabad Logistics Hub",
    "shutterType": "High-Speed Rapid Roll-Up Door",
    "logo": "assets/images/clients/68.jpg",
    "featured": false
  },
  {
    "id": "c-86",
    "name": "Corporate Client Partner #69",
    "sector": "Warehouses & Logistics",
    "locality": "Miyapur, Hyderabad",
    "shutterType": "Fire-Rated 4-Hour Steel Shutter",
    "logo": "assets/images/clients/69.jpg",
    "featured": false
  },
  {
    "id": "c-87",
    "name": "Corporate Client Partner #70",
    "sector": "Industrial & Manufacturing",
    "locality": "Banjara Hills, Hyderabad",
    "shutterType": "Automatic Remote-Controlled Shutter",
    "logo": "assets/images/clients/70.jpg",
    "featured": false
  },
  {
    "id": "c-88",
    "name": "Corporate Client Partner #71",
    "sector": "Commercial Offices",
    "locality": "Jubilee Hills, Hyderabad",
    "shutterType": "Architectural Aluminium Rolling Shutter",
    "logo": "assets/images/clients/71.jpg",
    "featured": false
  },
  {
    "id": "c-89",
    "name": "Corporate Client Partner #72",
    "sector": "Healthcare & Hospitality",
    "locality": "Begumpet Commercial Hub",
    "shutterType": "Heavy Duty Motorized Rolling Shutter",
    "logo": "assets/images/clients/72.jpg",
    "featured": false
  },
  {
    "id": "c-90",
    "name": "Corporate Client Partner #73",
    "sector": "Automotive & Workshops",
    "locality": "Uppal Industrial Area",
    "shutterType": "Perforated See-Through Security Shutter",
    "logo": "assets/images/clients/73.jpg",
    "featured": false
  },
  {
    "id": "c-91",
    "name": "Corporate Client Partner #74",
    "sector": "Retail & Showrooms",
    "locality": "Kukatpally, Hyderabad",
    "shutterType": "Galvanized Steel Industrial Shutter",
    "logo": "assets/images/clients/74.jpg",
    "featured": false
  },
  {
    "id": "c-92",
    "name": "Corporate Client Partner #75",
    "sector": "Warehouses & Logistics",
    "locality": "Madhapur, Hyderabad",
    "shutterType": "Transparent Polycarbonate Display Shutter",
    "logo": "assets/images/clients/75.jpg",
    "featured": false
  },
  {
    "id": "c-93",
    "name": "Corporate Client Partner #76",
    "sector": "Industrial & Manufacturing",
    "locality": "Gachibowli, Hyderabad",
    "shutterType": "High-Speed Rapid Roll-Up Door",
    "logo": "assets/images/clients/76.jpg",
    "featured": false
  },
  {
    "id": "c-94",
    "name": "Corporate Client Partner #77",
    "sector": "Commercial Offices",
    "locality": "Balanagar Industrial Area",
    "shutterType": "Fire-Rated 4-Hour Steel Shutter",
    "logo": "assets/images/clients/77.jpg",
    "featured": false
  },
  {
    "id": "c-95",
    "name": "Corporate Client Partner #78",
    "sector": "Healthcare & Hospitality",
    "locality": "Jeedimetla Industrial Estate",
    "shutterType": "Automatic Remote-Controlled Shutter",
    "logo": "assets/images/clients/78.jpg",
    "featured": false
  },
  {
    "id": "c-96",
    "name": "Corporate Client Partner #79",
    "sector": "Automotive & Workshops",
    "locality": "Cherlapally Industrial Belt",
    "shutterType": "Architectural Aluminium Rolling Shutter",
    "logo": "assets/images/clients/79.jpg",
    "featured": false
  },
  {
    "id": "c-97",
    "name": "Corporate Client Partner #80",
    "sector": "Retail & Showrooms",
    "locality": "Secunderabad Commercial Zone",
    "shutterType": "Heavy Duty Motorized Rolling Shutter",
    "logo": "assets/images/clients/80.jpg",
    "featured": false
  },
  {
    "id": "c-98",
    "name": "Corporate Client Partner #81",
    "sector": "Warehouses & Logistics",
    "locality": "Ameerpet, Hyderabad",
    "shutterType": "Perforated See-Through Security Shutter",
    "logo": "assets/images/clients/81.jpg",
    "featured": false
  },
  {
    "id": "c-99",
    "name": "Corporate Client Partner #82",
    "sector": "Industrial & Manufacturing",
    "locality": "LB Nagar Corridor",
    "shutterType": "Galvanized Steel Industrial Shutter",
    "logo": "assets/images/clients/82.jpg",
    "featured": false
  },
  {
    "id": "c-100",
    "name": "Corporate Client Partner #83",
    "sector": "Commercial Offices",
    "locality": "Kondapur, Hyderabad",
    "shutterType": "Transparent Polycarbonate Display Shutter",
    "logo": "assets/images/clients/83.jpg",
    "featured": false
  },
  {
    "id": "c-101",
    "name": "Corporate Client Partner #85",
    "sector": "Healthcare & Hospitality",
    "locality": "Sanathnagar Industrial Area",
    "shutterType": "High-Speed Rapid Roll-Up Door",
    "logo": "assets/images/clients/85.jpg",
    "featured": false
  },
  {
    "id": "c-102",
    "name": "Corporate Client Partner #87",
    "sector": "Automotive & Workshops",
    "locality": "Nacharam Industrial Area",
    "shutterType": "Fire-Rated 4-Hour Steel Shutter",
    "logo": "assets/images/clients/87.jpg",
    "featured": false
  },
  {
    "id": "c-103",
    "name": "Corporate Client Partner #88",
    "sector": "Retail & Showrooms",
    "locality": "Shamshabad Logistics Hub",
    "shutterType": "Automatic Remote-Controlled Shutter",
    "logo": "assets/images/clients/88.jpg",
    "featured": false
  },
  {
    "id": "c-104",
    "name": "Corporate Client Partner #89",
    "sector": "Warehouses & Logistics",
    "locality": "Miyapur, Hyderabad",
    "shutterType": "Architectural Aluminium Rolling Shutter",
    "logo": "assets/images/clients/89.jpg",
    "featured": false
  },
  {
    "id": "c-105",
    "name": "Corporate Client Partner #90",
    "sector": "Industrial & Manufacturing",
    "locality": "Banjara Hills, Hyderabad",
    "shutterType": "Heavy Duty Motorized Rolling Shutter",
    "logo": "assets/images/clients/90.jpg",
    "featured": false
  },
  {
    "id": "c-106",
    "name": "Corporate Client Partner #91",
    "sector": "Commercial Offices",
    "locality": "Jubilee Hills, Hyderabad",
    "shutterType": "Perforated See-Through Security Shutter",
    "logo": "assets/images/clients/91.jpg",
    "featured": false
  },
  {
    "id": "c-107",
    "name": "Corporate Client Partner #92",
    "sector": "Healthcare & Hospitality",
    "locality": "Begumpet Commercial Hub",
    "shutterType": "Galvanized Steel Industrial Shutter",
    "logo": "assets/images/clients/92.jpg",
    "featured": false
  },
  {
    "id": "c-108",
    "name": "Corporate Client Partner #93",
    "sector": "Automotive & Workshops",
    "locality": "Uppal Industrial Area",
    "shutterType": "Transparent Polycarbonate Display Shutter",
    "logo": "assets/images/clients/93.jpg",
    "featured": false
  },
  {
    "id": "c-109",
    "name": "Corporate Client Partner #94",
    "sector": "Retail & Showrooms",
    "locality": "Kukatpally, Hyderabad",
    "shutterType": "High-Speed Rapid Roll-Up Door",
    "logo": "assets/images/clients/94.jpg",
    "featured": false
  },
  {
    "id": "c-110",
    "name": "Corporate Client Partner #95",
    "sector": "Warehouses & Logistics",
    "locality": "Madhapur, Hyderabad",
    "shutterType": "Fire-Rated 4-Hour Steel Shutter",
    "logo": "assets/images/clients/95.jpg",
    "featured": false
  },
  {
    "id": "c-111",
    "name": "Corporate Client Partner #96",
    "sector": "Industrial & Manufacturing",
    "locality": "Gachibowli, Hyderabad",
    "shutterType": "Automatic Remote-Controlled Shutter",
    "logo": "assets/images/clients/96.jpg",
    "featured": false
  },
  {
    "id": "c-112",
    "name": "Corporate Client Partner #97",
    "sector": "Commercial Offices",
    "locality": "Balanagar Industrial Area",
    "shutterType": "Architectural Aluminium Rolling Shutter",
    "logo": "assets/images/clients/97.jpg",
    "featured": false
  },
  {
    "id": "c-113",
    "name": "Corporate Client Partner #98",
    "sector": "Healthcare & Hospitality",
    "locality": "Jeedimetla Industrial Estate",
    "shutterType": "Heavy Duty Motorized Rolling Shutter",
    "logo": "assets/images/clients/98.jpg",
    "featured": false
  },
  {
    "id": "c-114",
    "name": "Corporate Client Partner #99",
    "sector": "Automotive & Workshops",
    "locality": "Cherlapally Industrial Belt",
    "shutterType": "Perforated See-Through Security Shutter",
    "logo": "assets/images/clients/99.jpg",
    "featured": false
  }
];

export default CLIENTS_DATA;
